import { Controller } from "stimulus";

import { formatNumberToUSD, formatSubtotal } from "../../utils/cart";
export default class extends Controller {
  static targets = [
    "formQuantity",
    "formPurchasePolicy",
    "productCardQuantityText",
    "hideableIncrementor",
    "hiddenPurchasePolicyField",
    "plusButton",
    "minusButton",
    "modalSubtotal",
    "checkoutLineItem",
    "checkoutLineItemQuantity",
    "checkoutLineItemSubtotal",
    "checkoutLineItemPerUnitPrice",
    "checkoutFull",
    "checkoutEmpty",
    "productModalLink",
  ];

  submitForm() {
    this.dispatch("submitForm");
  }

  increment(event) {
    // event.preventDefault() required to prevent modal open when interacting with incrementer
    event.preventDefault();
    const productSku = event.currentTarget.dataset.productSku;
    this._incrementFormValue(productSku);
  }

  decrement(event) {
    // event.preventDefault() required to prevent modal open when interacting with decrementer
    event.preventDefault();
    const productSku = event.currentTarget.dataset.productSku;
    this._decrementFormValue(productSku);
  }

  removeItem(event) {
    const productSku = event.currentTarget.dataset.productSku;
    this._removeAllFormValue(productSku);
  }

  selectPurchasePolicy(event) {
    const productSku = event.currentTarget.dataset.productSku;
    let formQuantity = this._getCorrespondingFormRecord(productSku);
    let formPurchasePolicy =
      this._getCorrespondingPurchasePolicyFormRecord(productSku);
    this._resetQuantity(
      productSku,
      formQuantity.value,
      formPurchasePolicy.dataset.maxQtyValue,
    );
    this._setLineItemSubotal(productSku, formQuantity);
    this._setLineItemPerUnit(productSku, formPurchasePolicy);
    this._updateHiddenPurchasePolicy(productSku, formPurchasePolicy.value);
  }

  setItemQuantity({ detail: { data } }) {
    this._setFormValue(data.sku, data.quantity);
  }

  _resetQuantity(productSku, formQuantityValue, maxQtyValue) {
    if (Number(formQuantityValue) > Number(maxQtyValue)) {
      this._decrementFormValue(
        productSku,
        Number(formQuantityValue) - Number(maxQtyValue),
      );
    } else {
      this._togglePlusButton(
        productSku,
        maxQtyValue,
        Number(formQuantityValue),
      );
    }
  }

  _toggleIncrementor(productSku, formQuantityValue) {
    if (formQuantityValue == 0) {
      this._toggleVisibility(productSku);
    }
  }

  _toggleVisibility(productSku) {
    for (const hideableTarget of this.hideableIncrementorTargets) {
      if (hideableTarget.dataset.productSku == productSku) {
        hideableTarget.classList.toggle("hidden");
      }
    }
  }

  _updateTotalCount(totalIncrementValue) {
    this.checkoutTotalDiv = document.getElementById("checkout_count_total");
    if (this.checkoutTotalDiv) {
      this.checkoutTotalDiv.innerHTML =
        Number(this.checkoutTotalDiv.innerHTML) + Number(totalIncrementValue);
    }

    this.dispatch("updateTotalCount");
  }

  _decrementFormValue(productSku, incrementValueOverride) {
    const formQuantity = this._getCorrespondingFormRecord(productSku);

    this._updateProduct(productSku, formQuantity, () => {
      if (Number(formQuantity.value) > 0) {
        const totalIncrementValue =
          incrementValueOverride || Number(formQuantity.dataset.incrementValue);

        formQuantity.value =
          Number(formQuantity.value) - Number(totalIncrementValue);
        this._toggleIncrementor(productSku, Number(formQuantity.value));

        return true;
      }
    });
  }

  _setFormValue(productSku, quantity) {
    const formQuantity = this._getCorrespondingFormRecord(productSku);

    if (Number(formQuantity.value) === 0 || quantity === 0) {
      this._toggleIncrementor(productSku, 0);
    }

    this._updateProduct(productSku, formQuantity, () => {
      formQuantity.value = quantity;
      return true;
    });
  }

  _incrementFormValue(productSku) {
    const formQuantity = this._getCorrespondingFormRecord(productSku);

    this._updateProduct(productSku, formQuantity, (max, min) => {
      if (Number(formQuantity.value) < max) {
        const totalIncrementValue = formQuantity.dataset.incrementValue;
        this._toggleIncrementor(productSku, Number(formQuantity.value));
        formQuantity.value =
          Number(formQuantity.value) + Number(totalIncrementValue);
        return true;
      }
    });
  }

  _removeAllFormValue(productSku) {
    const formQuantity = this._getCorrespondingFormRecord(productSku);

    this._updateProduct(productSku, formQuantity, () => {
      formQuantity.value = 0;
      this._toggleIncrementor(productSku, Number(formQuantity.value));
      return true;
    });
  }

  _updateProduct(productSku, formQuantity, cb) {
    const formPurchasePolicy =
      this._getCorrespondingPurchasePolicyFormRecord(productSku);
    const maxQtyValue = Number(formPurchasePolicy.dataset.maxQtyValue);
    const minQtyValue = Number(formQuantity.dataset.minQtyValue);

    const priorQuantity = Number(formQuantity.value);

    if (cb(maxQtyValue, minQtyValue)) {
      const updatedQuantity = Number(formQuantity.value);

      this._togglePlusButton(productSku, maxQtyValue, updatedQuantity);
      this._toggleMinusButton(productSku, minQtyValue, updatedQuantity);
      this._updateQuantityText(productSku, updatedQuantity);
      this._updateTotalCount(updatedQuantity - priorQuantity);
      this._displayLineItem(productSku, updatedQuantity);
      this._setLineItemQuantity(productSku, updatedQuantity);
      this._setLineItemSubotal(productSku, formQuantity);
      this._toggleCheckoutLineItems();
      this._updateProductModalLink(productSku, formQuantity.value);
    }
  }

  _displayLineItem(productSku, FormQuantityValue) {
    for (const checkoutLineItem of this.checkoutLineItemTargets) {
      if (checkoutLineItem.dataset.productSku == productSku) {
        if (FormQuantityValue > 0) {
          checkoutLineItem.classList.remove("hidden");
        } else {
          checkoutLineItem.classList.add("hidden");
        }
      }
    }
  }

  _setLineItemQuantity(productSku, FormQuantityValue) {
    for (const checkoutLineItemQuantity of this
      .checkoutLineItemQuantityTargets) {
      if (checkoutLineItemQuantity.dataset.productSku == productSku) {
        checkoutLineItemQuantity.textContent = `${FormQuantityValue} ct`;
      }
    }
  }

  _setLineItemSubotal(productSku, formQuantity) {
    let formPurchasePolicy =
      this._getCorrespondingPurchasePolicyFormRecord(productSku);
    for (const checkoutLineItemSubtotal of this
      .checkoutLineItemSubtotalTargets) {
      if (checkoutLineItemSubtotal.dataset.productSku == productSku) {
        checkoutLineItemSubtotal.textContent = formatSubtotal(
          formQuantity.value,
          formPurchasePolicy.dataset.perUnitMidPrice,
          formQuantity.dataset.hasPriceRange,
        );
      }
    }
  }

  _setLineItemPerUnit(productSku, formPurchasePolicy) {
    for (const perUnitPrice of this.checkoutLineItemPerUnitPriceTargets) {
      if (perUnitPrice.dataset.productSku == productSku) {
        perUnitPrice.textContent = formatNumberToUSD(
          formPurchasePolicy.dataset.priceInUsd,
        );
      }
    }
  }

  _toggleCheckoutLineItems() {
    let populatedCart = this.formQuantityTargets.some(
      (x) => Number(x.value) > 0,
    );
    if (populatedCart) {
      for (const checkoutFull of this.checkoutFullTargets) {
        checkoutFull.classList.remove("hidden");
      }
      for (const checkoutEmpty of this.checkoutEmptyTargets) {
        checkoutEmpty.classList.add("hidden");
      }
    } else {
      for (const checkoutFull of this.checkoutFullTargets) {
        checkoutFull.classList.add("hidden");
      }
      for (const checkoutEmpty of this.checkoutEmptyTargets) {
        checkoutEmpty.classList.remove("hidden");
      }
    }
  }

  _updateQuantityText(productSku, formQuantityValue) {
    for (const quantityText of this.productCardQuantityTextTargets) {
      if (quantityText.dataset.productSku == productSku) {
        quantityText.innerHTML = ` ${formQuantityValue} ct`;
      }
    }
  }

  _togglePlusButton(productSku, maxQtyValue, formQuantityValue) {
    for (const plusButtonTarget of this.plusButtonTargets) {
      if (plusButtonTarget.dataset.productSku == productSku) {
        if (formQuantityValue < maxQtyValue) {
          plusButtonTarget.removeAttribute("disabled");
        } else {
          plusButtonTarget.setAttribute("disabled", true);
        }
      }
    }
  }

  _toggleMinusButton(productSku, minQtyValue, formQuantityValue) {
    for (const minusButtonTarget of this.minusButtonTargets) {
      if (minusButtonTarget.dataset.productSku == productSku) {
        if (formQuantityValue > 1) {
          // replace minus with trashcan
          minusButtonTarget.classList.remove("remove");
        } else {
          minusButtonTarget.classList.add("remove");
        }
        if (formQuantityValue > minQtyValue) {
          // disable button if bellow minimum
          minusButtonTarget.removeAttribute("disabled");
        } else {
          minusButtonTarget.setAttribute("disabled", true);
        }
      }
    }
  }

  _getCorrespondingFormRecord(productSku) {
    for (const formQuantity of this.formQuantityTargets) {
      if (formQuantity.dataset.productSku == productSku) {
        return formQuantity;
      }
    }
  }

  _getCorrespondingPurchasePolicyFormRecord(productSku) {
    for (const formPurchasePolicy of this.formPurchasePolicyTargets) {
      if (formPurchasePolicy.dataset.productSku == productSku) {
        if (formPurchasePolicy.checked) {
          return formPurchasePolicy;
        }
      }
    }
  }

  _updateHiddenPurchasePolicy(productSku, purchasePolicyId) {
    for (const hiddenPurchasePolicyField of this
      .hiddenPurchasePolicyFieldTargets) {
      if (hiddenPurchasePolicyField.dataset.productSku == productSku) {
        hiddenPurchasePolicyField.value = purchasePolicyId;
      }
    }
  }

  _updateProductModalLink(productSku, quantity) {
    for (const productModalLink of this.productModalLinkTargets) {
      if (productModalLink.dataset.productSku === productSku) {
        const url = new URL(productModalLink.href);
        const params = url.searchParams;

        if (Number(quantity) > 0) {
          params.set("quantity", quantity);
        } else {
          params.delete("quantity");
        }

        url.search = params.toString();
        productModalLink.setAttribute("href", url.href);
      }
    }
  }
}
